(() => {
  const rotators = document.querySelectorAll('[data-ts-announcement-rotator]');

  rotators.forEach((rotator) => {
    const slides = Array.from(rotator.querySelectorAll('[data-ts-announcement-slide]'));
    const previous = rotator.querySelector('[data-ts-announcement-previous]');
    const next = rotator.querySelector('[data-ts-announcement-next]');
    const toggle = rotator.querySelector('[data-ts-announcement-toggle]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const interval = Number(rotator.dataset.interval) || 6000;
    let activeIndex = 0;
    let timer;
    let paused = reduceMotion.matches;

    if (slides.length < 2) return;

    const show = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };

    const start = () => {
      stop();
      if (!paused && !reduceMotion.matches) {
        timer = window.setInterval(() => show(activeIndex + 1), interval);
      }
    };

    const setPaused = (value) => {
      paused = value;
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? 'Play rotating announcements' : 'Pause rotating announcements');
      start();
    };

    previous.addEventListener('click', () => {
      show(activeIndex - 1);
      start();
    });
    next.addEventListener('click', () => {
      show(activeIndex + 1);
      start();
    });
    toggle.addEventListener('click', () => setPaused(!paused));
    rotator.addEventListener('mouseenter', stop);
    rotator.addEventListener('mouseleave', start);
    rotator.addEventListener('focusin', stop);
    rotator.addEventListener('focusout', start);
    reduceMotion.addEventListener('change', () => setPaused(reduceMotion.matches));

    show(0);
    setPaused(paused);
  });
})();
